/**
 * Next scheduled run preview for weekly-hours enforcement jobs.
 * Days are 0=Mon … 6=Sun (matches DAY_LABELS / working_days).
 */
export function formatNextRunPreview({ days, hour, minute, now = new Date() }) {
  const dayList = Array.isArray(days) ? [...days].sort((a, b) => a - b) : [days];
  if (!dayList.length) return 'No days configured';

  const jsDayToMon0 = (jsDay) => (jsDay + 6) % 7; // JS: 0=Sun → Mon=0
  const currentMon0 = jsDayToMon0(now.getDay());
  const currentMinutes = now.getHours() * 60 + now.getMinutes();
  const targetMinutes = Number(hour) * 60 + Number(minute);

  for (let offset = 0; offset < 8; offset += 1) {
    const candidate = (currentMon0 + offset) % 7;
    if (!dayList.includes(candidate)) continue;
    if (offset === 0 && currentMinutes >= targetMinutes) continue;
    const runAt = new Date(now);
    runAt.setDate(now.getDate() + offset);
    runAt.setHours(Number(hour), Number(minute), 0, 0);
    return runAt.toLocaleString(undefined, {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
  return '—';
}

export const REMINDER_LEVEL_OPTIONS = ['gentle', 'warning', 'final'];

export const HOUR_OPTIONS = Array.from({ length: 24 }, (_, i) => i);
export const MINUTE_OPTIONS = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
